import { io, Socket } from 'socket.io-client';
import { SOCKET_URL } from '../config/api';
import { kc } from '../auth/keycloak';
import { ensureFreshToken } from '../auth/sessionExpiry';

export const socket: Socket = io(SOCKET_URL, {
    autoConnect: false,
    transports: ['websocket'],
    auth: (cb) => {
        cb({ token: kc.token ?? '' });
    },
});

export const connectSocket = async (): Promise<void> => {
    if (socket.connected) return;
    try {
        // Make sure we hand over a fresh token, same 30s buffer as client.ts.
        await ensureFreshToken();
    } catch (err) {
        console.error('[socket] token refresh failed before connect', err);
    }
    socket.connect();
};

export const disconnectSocket = (): void => {
    if (!socket.connected) return;
    socket.disconnect();
};

export default socket;